export const HUB_INSTRUCTIONS = [
  {
    text: "1. The biggest box in your package is the Lilli hub.",
  },
  {
    text: "2. Plug it into a central location in the home (see tips).",
  },
  {
    note: "You can use the ethernet cable if there is low connectivity.",
  },
  {
    hint: [
      "Find a spot that isn't behind any large objects or in a cupboard, as this will make it harder to receive the signals from the sensor network.",
    ],
  },
];
